module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-creative-intro-card1.1@2x.5125b647.jpg";